module.exports = __webpack_public_path__ + "static/img/点击.18d101e5.png";